/**
 * E-BUNDLE-10 — das Pfad-Praedikat, getrennt vom Router.
 *
 * `main.tsx` muss VOR dem ersten Render wissen, ob die aktuelle URL ein
 * oeffentlicher Auth-Pfad ist: nur so bleibt `SessionProvider` (das bei 401
 * auf /v1/auth/login umleitet) fuer diese Pfade ungemountet. Diese eine
 * Entscheidung ist synchron — der Router dahinter ist es nicht.
 *
 * Solange `isPublicAuthPath` in `PublicAuthRouter.tsx` stand, zog der
 * synchrone Import des Praedikats den kompletten Public-Auth-Ast in den
 * Entry-Chunk: AcceptInvitePage, AccountDeletionPage, RegisterPage,
 * VerifyEmailPages, PublicAuthShell und public-auth-api, zusammen rund
 * 40 kB Quelltext — auf jedem Start, obwohl der angemeldete Normalfall
 * keine dieser Seiten je rendert. Das Praedikat hier (wenige Zeilen, keine
 * React-Abhaengigkeit) bleibt im Entry, der Router wandert hinter `lazy()`.
 */

/** Pfad-Praefixe, die ohne Session gerendert werden. */
export const PUBLIC_AUTH_PATH_PREFIXES = [
  "/register",
  "/verify-email-sent",
  "/verify-email-required",
  "/accept-invite",
  "/account/delete",
] as const;

export function isPublicAuthPath(pathname: string): boolean {
  return PUBLIC_AUTH_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
